import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Typography } from '@telus-uds/components-web';

import { Thead, Tr, Th, Td } from './css';
import getFormattedPricing from '../../utils';
import Row from './row';

const Table = ({
  hardware,
  productSelected,
  viewType,
  technicalServices,
  setTechnicalServices,
  list,
  total,
  setTotal
}) => {
  const { technicalServices: technicalServicesTotal } = total;

  const getHeader = headerList => (
    <Thead>
      <Tr>
        {headerList.map(item => (
          <Th>{_.get(item, 'fields.title', '')}</Th>
        ))}
      </Tr>
    </Thead>
  );

  useEffect(() => {
    const grandTotal = Object.keys(technicalServices).reduce((acc, current) => {
      const { servicePrice, quantity } = technicalServices[current];
      return acc + servicePrice * +quantity;
    }, 0);
    setTotal(previousValue => ({
      ...previousValue,
      technicalServices: grandTotal
    }));
  }, [technicalServices]);

  return (
    <table>
      {list.map(serviceItem =>
        _.get(serviceItem, 'fields.isHeader', false) ? (
          getHeader(_.get(serviceItem, 'fields.headerList', []))
        ) : (
          <Row
            key={_.get(serviceItem, 'sys.id', '')}
            hardware={hardware}
            productSelected={productSelected}
            viewType={viewType}
            rowData={serviceItem}
            technicalServices={technicalServices}
            setTechnicalServices={setTechnicalServices}
          />
        )
      )}
      <Tr style={{ background: '#f4f4f4' }}>
        <Td colSpan={5}>
          <Typography variant={{ bold: true }}>Total</Typography>
        </Td>
        <Td>
          <Typography variant={{ bold: true }}>{getFormattedPricing(technicalServicesTotal)}</Typography>
        </Td>
      </Tr>
    </table>
  );
};

Table.propTypes = {
  hardware: PropTypes.shape({}).isRequired,
  productSelected: PropTypes.string.isRequired,
  viewType: PropTypes.string.isRequired,
  list: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  technicalServices: PropTypes.arrayOf(
    PropTypes.shape({
      servicePrice: PropTypes.number,
      quantity: PropTypes.number
    })
  ).isRequired,
  setTechnicalServices: PropTypes.func.isRequired,
  total: PropTypes.shape({
    ratePlan: PropTypes.number,
    subscriberList: PropTypes.number,
    additionalServices: PropTypes.number,
    addons: PropTypes.number,
    hardware: PropTypes.number,
    accessories: PropTypes.number,
    deliveryCharges: PropTypes.number,
    technicalServices: PropTypes.number
  }).isRequired,
  setTotal: PropTypes.func.isRequired
};

export default Table;
